import getters from './getters';
import actions from './actions';
import mutations from './mutations';
var state = function state() {
  return {
    total: null,
    products: null,
    description: null,
    productsPerPage: 40,
    tpl: 'liste produits'
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};